import React, { useEffect, useRef, useState } from "react";
import "../style/fonts.css";
import Welcome from "./HomeScreen/Welcome";
import FastData from "./HomeScreen/FastData";
import DashboardCharts from "./HomeScreen/DashboardCharts";

function Home() {
  return (
    <div className="content-wrapper" style={{ backgroundColor: "#ccc" }}>
      <Welcome />
      <FastData />
      <DashboardCharts />
    </div>
  );
}

export default Home;
